<template>
  <div>
    <!-- 作者 -->
    <Author :author-info="authorData"></Author>
    <!-- 图片？ -->
    <MaybePic></MaybePic>
    <!-- Markdown目录 -->
    <MarkdownTree v-if="navTree.length !== 0" :tree-data="navTree"></MarkdownTree>
  </div>
</template>

<script>

import Author from "@/views/article/share/components/Author";
import MaybePic from "@/views/article/share/components/MaybePic";
import MarkdownTree from "@/views/article/share/components/MarkdownTree";

export default {
  name: "AuthorAndMenuTree",
  components: {
    MarkdownTree,
    MaybePic,
    Author,
  },
  props: {
    authorData: Object,
    navTree: Array,
  }
}
</script>